module.exports = __webpack_public_path__ + "static/media/школа корридор.2fd6f728.jpg";